import styles from './SmsPreviewTemplate.module.css'

const TEMPLATE_CONFIG = {
  'Template 1': {
    intro: (name, title, companyName) =>
      `Hi ${name || '[Candidate First Name]'},\n\n${companyName || '[Company]'} reviewed your profile and invited you to apply for ${title || '[Job Title]'}. View your invitation:`,
  },
  'Template 2': {
    intro: (name, title, companyName) =>
      `Hi ${name || '[Candidate First Name]'},\n\nYour invitation for ${title || '[Job title]'} is waiting. Submit your bid:`,
  },
  'Template 3': {
    intro: (name, title, companyName) =>
      `Hi ${name || '[Candidate First Name]'},\n\n${companyName || '[Employer Name]'} wants you to apply for ${title || '[Job Title]'}. View:`,
  },
}

const BackChevron = () => (
  <svg className={styles.backChevron} viewBox="0 0 10 16" fill="none">
    <polyline
      points="8,2 2,8 8,14"
      stroke="#000000"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const ChevronDown = () => (
  <svg className={styles.chevronDown} viewBox="0 0 10 10" fill="none">
    <polyline
      points="3,2 7,5 3,8"
      stroke="#000000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const CameraIcon = () => (
  <svg className={styles.cameraIcon} viewBox="0 0 28 22" fill="none">
    <path
      d="M10.8 1.5L9.2 4H3.5C2.12 4 1 5.12 1 6.5V18.5C1 19.88 2.12 21 3.5 21H24.5C25.88 21 27 19.88 27 18.5V6.5C27 5.12 25.88 4 24.5 4H18.8L17.2 1.5H10.8Z"
      fill="#3C3C43"
      fillOpacity="0.6"
    />
    <circle cx="14" cy="13" r="5" fill="white" />
    <circle cx="14" cy="13" r="3.5" fill="#3C3C43" fillOpacity="0.6" />
  </svg>
)

const MicIcon = () => (
  <svg className={styles.micIcon} viewBox="0 0 12 18" fill="none">
    <path
      d="M2.92188 8.4751C2.92188 10.3843 4.15039 11.729 5.94336 11.729C7.72803 11.729 8.95654 10.3843 8.95654 8.4751V3.25391C8.95654 1.33643 7.72803 0 5.94336 0C4.15039 0 2.92188 1.33643 2.92188 3.25391V8.4751ZM4.17529 8.4751V3.25391C4.17529 2.02539 4.88086 1.23682 5.94336 1.23682C7.00586 1.23682 7.70312 2.02539 7.70312 3.25391V8.4751C7.70312 9.70361 7.00586 10.4922 5.94336 10.4922C4.88086 10.4922 4.17529 9.70361 4.17529 8.4751ZM0 8.77393C0 12.0278 2.1499 14.3105 5.3125 14.5762V16.5103H2.23291C1.88428 16.5103 1.60205 16.7925 1.60205 17.1411C1.60205 17.4897 1.88428 17.7637 2.23291 17.7637H9.64551C9.99414 17.7637 10.2764 17.4897 10.2764 17.1411C10.2764 16.7925 9.99414 16.5103 9.64551 16.5103H6.56592V14.5762C9.73682 14.3105 11.8784 12.0278 11.8784 8.77393V7.08887C11.8784 6.74023 11.6045 6.46631 11.2559 6.46631C10.9072 6.46631 10.625 6.74023 10.625 7.08887V8.72412C10.625 11.5547 8.78223 13.4307 5.94336 13.4307C3.09619 13.4307 1.25342 11.5547 1.25342 8.72412V7.08887C1.25342 6.74023 0.979492 6.46631 0.622559 6.46631C0.273926 6.46631 0 6.74023 0 7.08887V8.77393Z"
      fill="#3C3C43"
      fillOpacity="0.6"
    />
  </svg>
)

const SkillGigsAvatar = () => (
  <svg className={styles.sgAvatar} viewBox="0 0 40 40" fill="none">
    <rect width="40" height="40" rx="20" fill="#FC1254" />
    <g clipPath="url(#sgAvatarClip)">
      <path
        d="M9.43919 18.2585V18.3973C9.44406 18.6788 9.5033 18.9566 9.61348 19.2146C9.72366 19.4726 9.88262 19.7058 10.0812 19.9007C10.2798 20.0956 10.5141 20.2484 10.7706 20.3502C11.0271 20.4521 11.3007 20.501 11.5758 20.4942H15.2627C16.9132 20.4942 18.2485 21.8075 18.2485 23.4261V23.567C18.2485 25.1857 16.9132 26.4989 15.2627 26.4989H7.77623C7.5925 26.4989 7.4163 26.5736 7.28639 26.7066C7.15648 26.8395 7.0835 27.0199 7.0835 27.2079C7.0835 27.3959 7.15648 27.5762 7.28639 27.7092C7.4163 27.8421 7.5925 27.9168 7.77623 27.9168H15.2627C17.7102 27.9168 19.6945 25.9694 19.6945 23.567V23.4282C19.7029 21.0238 17.7186 19.0827 15.2627 19.0827H11.5758C11.4861 19.085 11.3968 19.069 11.3131 19.0357C11.2294 19.0024 11.1531 18.9524 11.0884 18.8886C11.0238 18.8248 10.9722 18.7486 10.9366 18.6642C10.901 18.5799 10.8821 18.4891 10.881 18.3973V18.2585C10.8875 18.0757 10.9641 17.9029 11.0941 17.7774C11.2241 17.652 11.3971 17.5839 11.5758 17.588H19.0602C19.2439 17.588 19.4201 17.5108 19.55 17.3779C19.6799 17.2449 19.7529 17.0646 19.7529 16.8766C19.7529 16.6885 19.6799 16.5082 19.55 16.3753C19.4201 16.2423 19.2439 16.1676 19.0602 16.1676H11.5758C11.3007 16.1608 11.0271 16.2097 10.7706 16.3116C10.5141 16.4134 10.2798 16.5662 10.0812 16.7611C9.88262 16.956 9.72366 17.1892 9.61348 17.4472C9.5033 17.7052 9.44406 17.983 9.43919 18.2585Z"
        fill="white"
      />
      <path
        d="M11.5758 13.9116C9.1283 13.9116 7.14401 15.857 7.14401 18.2593V18.3981C7.14401 20.8004 9.1283 22.7479 11.5758 22.7479H15.2627C15.4421 22.7513 15.6155 22.8205 15.7452 22.9473C15.875 23.0741 15.9505 23.2482 15.9554 23.4318V23.5728C15.9535 23.6639 15.9341 23.7538 15.8983 23.8372C15.8624 23.9206 15.8109 23.9961 15.7465 24.0591C15.6822 24.1222 15.6064 24.1717 15.5234 24.2047C15.4403 24.2377 15.3518 24.2537 15.2627 24.2517H7.77623C7.5925 24.2517 7.4163 24.3264 7.28639 24.4594C7.15648 24.5923 7.0835 24.7727 7.0835 24.9607C7.0835 25.1487 7.15648 25.329 7.28639 25.462C7.4163 25.5949 7.5925 25.6696 7.77623 25.6696H15.2627C15.5383 25.6775 15.8127 25.6295 16.07 25.5283C16.3274 25.4271 16.5625 25.2747 16.762 25.0799C16.9614 24.8851 17.1212 24.6518 17.232 24.3935C17.3428 24.1351 17.4025 23.8568 17.4077 23.5748V23.436C17.4031 23.1535 17.3438 22.8748 17.2332 22.6159C17.1226 22.3571 16.963 22.1233 16.7634 21.9281C16.5639 21.7328 16.3286 21.58 16.071 21.4786C15.8134 21.3772 15.5386 21.3289 15.2627 21.3369H11.5758C9.92536 21.3369 8.5858 20.0237 8.5858 18.405V18.2662C8.5858 16.6476 9.92118 15.3364 11.5716 15.3364H19.0602C19.2439 15.3364 19.4201 15.2617 19.55 15.1288C19.6799 14.9958 19.7529 14.8155 19.7529 14.6275C19.7529 14.4394 19.6799 14.2591 19.55 14.1262C19.4201 13.9932 19.2439 13.9185 19.0602 13.9185H11.5758V13.9116Z"
        fill="white"
      />
      <path
        d="M31.9829 19.5946C31.5377 19.2439 30.9902 19.0567 30.4284 19.0629H26.7832C26.5037 19.0629 26.2787 19.2929 26.2787 19.5746C26.2787 19.8562 26.5037 20.0862 26.7832 20.0862H30.4493C30.6817 20.0845 30.9084 20.1593 31.0961 20.2997C31.2491 20.4141 31.3688 20.5689 31.4423 20.7476C31.5158 20.9263 31.5404 21.1221 31.5134 21.314C31.3589 22.3418 30.9287 23.3056 30.2705 24.0979C29.6124 24.8901 28.7523 25.4799 27.7859 25.8013C26.8196 26.1228 25.7851 26.1634 24.7975 25.9185C23.81 25.6737 22.9083 25.153 22.1928 24.4146C21.1833 23.3786 20.6164 21.9753 20.6164 20.5122C20.6164 19.0491 21.1833 17.6457 22.1928 16.6098C23.1418 15.6277 24.4109 15.0376 25.7579 14.9521C27.1049 14.8666 28.4355 15.2918 29.4957 16.1464C29.6292 16.2564 29.7975 16.3124 29.9687 16.3038C30.1399 16.2951 30.302 16.2224 30.4242 16.0994C30.5589 15.9651 30.6311 15.7801 30.6243 15.5892C30.6174 15.3983 30.5319 15.2191 30.3881 15.0952C29.09 14.0614 27.495 13.5223 25.8651 13.5727C24.1047 13.6284 22.433 14.3764 21.1976 15.6611C20.254 16.643 19.6156 17.8889 19.3629 19.2415C19.1102 20.5942 19.2545 21.9932 19.7776 23.2621C20.3007 24.531 21.1791 25.613 22.3022 26.3717C23.4253 27.1304 24.7427 27.5318 26.0884 27.5253C27.7431 27.5289 29.3438 26.9224 30.5974 25.817C31.8315 24.7264 32.6416 23.2183 32.8801 21.5676C32.941 21.1368 32.8899 20.6973 32.7321 20.2932C32.5742 19.8891 32.3151 19.5346 31.9808 19.2656"
        fill="white"
      />
      <path
        d="M28.8577 17.677C28.929 17.6056 28.9842 17.519 29.0192 17.4234C29.0543 17.3278 29.0684 17.2255 29.0607 17.1237C29.0529 17.0219 29.0234 16.9231 28.9743 16.8342C28.9252 16.7454 28.8576 16.6686 28.7764 16.6093C27.8723 15.9622 26.7736 15.6633 25.6749 15.7657C24.5762 15.8681 23.5484 16.3652 22.7734 17.1688C21.9127 18.0498 21.4292 19.2446 21.4292 20.4904C21.4292 21.7362 21.9127 22.931 22.7734 23.812C23.3827 24.4389 24.1498 24.8806 24.9897 25.088C25.8295 25.2954 26.7091 25.2604 27.5307 24.9869C28.3522 24.7134 29.0836 24.2122 29.6435 23.5388C30.2034 22.8655 30.5699 22.0464 30.7022 21.1727C30.7077 21.1385 30.7057 21.1035 30.6963 21.0703C30.6869 21.0371 30.6704 21.0064 30.648 20.9805C30.6266 20.9548 30.6001 20.9343 30.5702 20.9203C30.5403 20.9062 30.5077 20.8991 30.4748 20.8993H26.7858C26.5063 20.8993 26.2812 21.1292 26.2812 21.411C26.2812 21.6927 26.5063 21.9227 26.7858 21.9227H28.8369C28.5671 22.3389 28.2103 22.6884 27.7922 22.9459C27.3741 23.2034 26.9052 23.3625 26.4196 23.4116C25.934 23.4606 25.4438 23.3985 24.9845 23.2296C24.5253 23.0607 24.1086 22.7893 23.7645 22.4352C23.4591 22.1223 23.2184 21.7496 23.0567 21.3394C22.8951 20.9293 22.8157 20.49 22.8235 20.0478C22.8467 19.1924 23.1869 18.378 23.775 17.7698C24.3632 17.1615 25.1553 16.8049 25.9908 16.7721C26.7 16.7437 27.3986 16.9546 27.9793 17.3722C28.1125 17.4663 28.2737 17.5097 28.4349 17.4949C28.5962 17.4801 28.7472 17.408 28.8619 17.291L28.8577 17.677Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="sgAvatarClip">
        <rect width="27.6923" height="27.6923" fill="white" transform="translate(6.15381 6.15381)" />
      </clipPath>
    </defs>
  </svg>
)

const SmsPreviewTemplate = ({
  talentFirstName,
  jobTitle,
  jobDetails = [],
  message,
  selectedTemplate = 'Template 1',
  companyName,
}) => {
  const config = TEMPLATE_CONFIG[selectedTemplate] || TEMPLATE_CONFIG['Template 1']
  const intro = config.intro(talentFirstName || '[Candidate First Name]', jobTitle || '[Job Title]', companyName || '[Company Name]')

  return (
    <div className={styles.container}>
      {/* Nav Bar */}
      <div className={styles.navBar}>
        <BackChevron />
        <div className={styles.contactInfo}>
          <SkillGigsAvatar />
          <span className={styles.contactName}>
            Skillgigs
            <ChevronDown />
          </span>
        </div>
      </div>

      {/* Messages */}
      <div className={styles.messagesArea}>
        <div className={styles.timestamp}>Yesterday 9:41</div>
        <div className={styles.bubble}>
          <p style={{ whiteSpace: 'pre-wrap' }}>
            {intro} <span className={styles.link}>[Link]</span>
          </p>
          <p>Reply STOP to opt out.</p>
        </div>
      </div>

      {/* Input Bar */}
      <div className={styles.inputBar}>
        <CameraIcon />
        <div className={styles.inputField}>
          <span>SMS/MMS</span>
          <MicIcon />
        </div>
      </div>

      {/* Home Indicator */}
      <div className={styles.homeIndicator}>
        <div className={styles.homeBar} />
      </div>
    </div>
  )
}

export default SmsPreviewTemplate
